import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { FIELD_FILLING_TYPES } from '../../../../utils/fields/getFieldProps';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import ErrorBlock from '../../../common/ErrorBlock';
import SelectCustom from '../../../SelectCustom';
import TextInput from '../../../TextInput';
import styles from './index.styl';

const {
  POSTAL_CODE,
  ADDRESS_1,
  STATE,
  CITY,
  COUNTRY,
  ADDRESS_2,
  HOME_PHONE,
} = PROFILE_FIELDS_TYPES;

export function HomeAddressColumnModeView({
  targetCountryEntity,
  postalCode,
  address1,
  address2,
  city,
  state,
  country,
  homePhone,
  onChange,
  countryList,
  validateErrors,
  isZipApplicable,
  statesList,
  zipLimit,
  makeProfileField,
  handleCountryChange,
  formatMessage,
  zipExamples,
  isAppointmentPatientForm,
}) {
  return (
    <div className={styles.root}>
      <div className={styles.column}>
        {/*     ADDRESS_1     */}
        <TextInput {...makeProfileField(ADDRESS_1)} value={address1} />
        <FormErrorBlock type={ADDRESS_1} errors={validateErrors} />

        {/*     ADDRESS_2     */}
        <TextInput {...makeProfileField(ADDRESS_2)} value={address2} />
        <FormErrorBlock type={ADDRESS_2} errors={validateErrors} />
      </div>

      <div className={styles.column}>
        {/*     CITY     */}
        <TextInput {...makeProfileField(CITY)} value={city} />
        <FormErrorBlock type={CITY} errors={validateErrors} />

        {/*     STATE     */}
        <div>
          <SelectCustom
            {...makeProfileField(STATE, FIELD_FILLING_TYPES.REQUIRED)}
            onChange={data => onChange({ state: data })}
            value={state}
            options={statesList}
            needUpdateDefaultValue
            required
          />
          <FormErrorBlock type={STATE} errors={validateErrors} />
        </div>
      </div>

      <div className={styles.column}>
        {/*     POSTAL CODE     */}
        <div>
          <TextInput
            {...makeProfileField(
              POSTAL_CODE,
              isAppointmentPatientForm && FIELD_FILLING_TYPES.REQUIRED,
            )}
            limit={zipLimit}
            value={postalCode}
            disabled={!isZipApplicable}
          />
          <If condition={get(validateErrors, POSTAL_CODE)}>
            <ErrorBlock
              errors={[
                formatMessage(
                  {
                    id: 'errors.validation.profile.postalCode.format',
                  },
                  { example: zipExamples },
                ),
              ]}
              className="mt3 w-100"
            />
          </If>
        </div>

        {/*     COUNTRY     */}
        <div>
          <SelectCustom
            {...makeProfileField(COUNTRY, FIELD_FILLING_TYPES.REQUIRED)}
            onChange={val => handleCountryChange(val)}
            value={country || targetCountryEntity}
            options={countryList}
            needUpdateDefaultValue
            required
          />
          <FormErrorBlock type={COUNTRY} errors={validateErrors} />
        </div>
      </div>

      <div className={styles.column}>
        {/*     HOME_PHONE     */}
        <TextInput {...makeProfileField(HOME_PHONE)} value={homePhone} />
        <FormErrorBlock type={HOME_PHONE} errors={validateErrors} />
      </div>
    </div>
  );
}

HomeAddressColumnModeView.propTypes = {
  postalCode: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  country: PropTypes.object,
  homePhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  statesList: PropTypes.array,
  countryList: PropTypes.array,
  zipLimit: PropTypes.number,
  onCountryChange: PropTypes.func,
  isZipApplicable: PropTypes.bool,
  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  targetCountryEntity: PropTypes.object,
  makeProfileField: PropTypes.func,
  handleCountryChange: PropTypes.func,
  formatMessage: PropTypes.func,
  zipExamples: PropTypes.string,
  isAppointmentPatientForm: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/HomeAddress/HomeAddressFormSection/HomeAddressColumnModeView.jsx